<mat-list>
  <mat-list-item class="mat-list-item-overflow-fix" *ngFor="let file of files; last as isLast">
    <img matListItemAvatar class="rounded-0" style="cursor: pointer;" (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)" [src]="file.url" [alt]="file.name" *ngIf="isImage(file.name)" />
    <img matListItemAvatar class="rounded-0" style="cursor: pointer;" (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)" [alt]="file.name" src="./assets/images/document-placeholder.png" *ngIf="!isImage(file.name)" />
    <div matListItemTitle class="text-wrap" style="cursor: pointer;" (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)" [matTooltip]="file.name"> {{ file.name | truncateFileName:30 }} </div>
    <div matListItemLine class="text-wrap" style="cursor: pointer;" (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)"> Created: {{ (file.date_created * 1000) | timezoneConvertMedium }} </div>
    <div matListItemLine class="text-wrap" style="cursor: pointer;" (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)"> Last Modified: {{ (file.date_modified * 1000) | timezoneConvertMedium }} </div>

    <button
      matListItemMeta
      mat-icon-button
      ngxClipboard
      aria-label="Copy file URL"
      matTooltip="Copy this file URL."
      [cbContent]="file.url"
      (click)="onCopiedURL()"
      class="dialog-button my-auto ml-2 mr-0"
      style="cursor: pointer;">
      <mat-icon>content_copy</mat-icon>
    </button>

    <button
      matListItemMeta
      mat-icon-button
      aria-label="Download file"
      matTooltip="Download this file."
      (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)"
      class="dialog-button my-auto ml-2 mr-0"
      style="cursor: pointer;">
      <mat-icon>download</mat-icon>
    </button>

    <button
      matListItemMeta
      mat-icon-button
      aria-label="Preview file"
      matTooltip="View this file."
      (click)="onOpenUrl(file.url)"
      class="dialog-button my-auto ml-2 mr-0"
      style="cursor: pointer;">
      <mat-icon>preview</mat-icon>
    </button>

    <button
      matListItemMeta
      mat-icon-button
      color="warn"
      aria-label="Delete file"
      matTooltip="Delete this file."
      (click)="delete(file.id)"
      [disabled]="!file.id"
      *ngIf="!view"
      class="dialog-remove-button my-auto ml-2 mr-0">
      <mat-icon>delete</mat-icon>
    </button>
    <mat-divider class="w-100 m-0" [inset]="true" *ngIf="!isLast"></mat-divider>
  </mat-list-item>
</mat-list>
